import React from 'react'
import NavBar from '../../NavBar/NavBar'

function NotFoundPage() {
    return (
        <div className='NotFoundPage'>
            <NavBar />
            <h1>Page not found</h1>
        </div>
    )
}

export default NotFoundPage